<!--
 * @Author: wzh
 * @LastEditTime: 2024-10-26 14:09:25
 * @Description: 账号安全 账号设置
-->

<template>
  <div class="user_set">
    <ul class="list">
      <li class="item">
        <div class="left">
          <a-icon type="check-circle" style="color: #6ed421" />
          <span class="title">{{ $t("home.account_set.password") }}</span>
        </div>
        <span class="info">{{ $t("home.account_set.password_tip") }}</span>
        <a-button @click="openDialog('updatePass')">{{
          $t("home.account_set.password_btn")
        }}</a-button>
      </li>
      <li class="item">
        <div class="left">
          <a-icon
            type="check-circle"
            style="color: #6ed421"
            v-if="userInfo.questionVos.length"
          />
          <a-icon type="exclamation-circle" style="color: #ff3939" v-else />
          <span class="title">{{ $t("home.account_set.question") }}</span>
        </div>
        <span class="info">{{ $t("home.account_set.question_tip") }}</span>
        <a-button type="primary" @click="openDialog('safe')">
          {{
            userInfo.questionVos.length
              ? $t("home.account_set.question_btn_edit")
              : $t("home.account_set.question_btn_add")
          }}
        </a-button>
      </li>
      <li class="item" v-if="basicSetInfo.sfqybm == 1">
        <div class="left">
          <a-icon
            type="check-circle"
            style="color: #6ed421"
            v-if="userInfo.alias"
          />
          <a-icon type="exclamation-circle" style="color: #ff3939" v-else />
          <span class="title">{{ $t("home.account_set.alias") }}</span>
        </div>
        <span class="info">{{ $t("home.account_set.alias_tip") }}</span>
        <div class="right">
          <span class="showArea">{{ userInfo.alias }}</span>
          <a-button type="primary" @click="openDialog('loginAlias')">
            {{
              userInfo.alias
                ? $t("home.account_set.alias_btn_edit")
                : $t("home.account_set.alias_btn_add")
            }}
          </a-button>
        </div>
      </li>
      <li class="item">
        <div class="left">
          <a-icon
            type="check-circle"
            style="color: #6ed421"
            v-if="userInfo.email"
          />
          <a-icon type="exclamation-circle" style="color: #ff3939" v-else />
          <span class="title">{{ $t("home.account_set.email") }}</span>
        </div>
        <span class="info">{{ $t("home.account_set.email_tip") }}</span>
        <div class="right">
          <span class="showArea">{{ formatterStar(userInfo.email) }}</span>
          <a-button type="primary" @click="openDialog('email')">
            {{
              userInfo.email
                ? $t("home.account_set.email_btn_edit")
                : $t("home.account_set.email_btn_add")
            }}
          </a-button>
        </div>
      </li>
      <li class="item">
        <div class="left">
          <a-icon
            type="check-circle"
            style="color: #6ed421"
            v-if="userInfo.mobile"
          />
          <a-icon type="exclamation-circle" style="color: #ff3939" v-else />
          <span class="title">{{ $t("home.account_set.mobile") }}</span>
        </div>
        <span class="info">{{ $t("home.account_set.mobile_tip") }}</span>
        <div class="right">
          <span class="showArea">{{ formatterStar(userInfo.mobile) }}</span>
          <a-button type="primary" @click="openDialog('phone')">
            {{
              userInfo.mobile
                ? $t("home.account_set.mobile_btn_edit")
                : $t("home.account_set.mobile_btn_add")
            }}
          </a-button>
        </div>
      </li>
    </ul>

    <!-- 修改密码弹窗 -->
    <Dialog
      ref="updatePass"
      width="700px"
      :title="$t('home.account_set.password')"
      :saveText="$t('base.btn.sure')"
      @handleOk="updatePass"
    >
      <UpdatePass
        ref="updatePassForm"
        :safeSetInfo="safeSetInfo"
        :pswSetInfo="pswSetInfo"
      />
    </Dialog>

    <!-- 安全问题弹窗 -->
    <Dialog
      ref="safe"
      width="900px"
      :title="$t('home.account_set.question')"
      :saveText="$t('base.btn.sure')"
      @handleOk="saveQus"
    >
      <Safe ref="safeForm" :selfQus="userInfo.questionVos" />
    </Dialog>

    <!-- 登录别名弹窗 -->
    <Dialog
      ref="loginAlias"
      width="700px"
      :title="$t('home.account_set.alias')"
      :saveText="$t('base.btn.sure')"
      @handleOk="setAliasOk"
    >
      <LoginAlias ref="aliasForm" :selfAlias="userInfo.alias" />
    </Dialog>

    <!-- 邮箱绑定弹窗 -->
    <Dialog
      ref="email"
      width="700px"
      :title="$t('home.account_set.email')"
      :saveText="$t('base.btn.sure')"
      @handleOk="setMailOk"
    >
      <Email ref="emailForm" :selfEmail="userInfo.email" />
    </Dialog>

    <!-- 手机号绑定弹窗 -->
    <Dialog
      ref="phone"
      width="700px"
      :title="$t('home.account_set.mobile')"
      :saveText="$t('base.btn.sure')"
      @handleOk="setPhoneOk"
    >
      <Phone ref="phoneForm" :selfMobile="userInfo.mobile" />
    </Dialog>
  </div>
</template>

<script>
import { Dialog } from "@/components/public/dialog/ant";
import UpdatePass from "../components/UpdatePass";
import Safe from "../components/Safe";
import LoginAlias from "../components/LoginAlias";
import Email from "../components/Email";
import Phone from "../components/Phone";
import { commonAPI } from "@/apis";
import { mapGetters } from "vuex";
import { encryptAES } from "@/utils";

export default {
  name: "set",
  components: { Dialog, UpdatePass, Safe, LoginAlias, Email, Phone },
  data() {
    return {
      basicSetInfo: {},
      safeSetInfo: {},
      pswSetInfo: {},
      userInfo: {
        alias: "",
        email: "",
        mobile: "",
        questionVos: [],
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  created() {
    this.getBasicSet();
    this.getSafeSet();
    this.getPswSet();
    this.getUserInfo();
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      const { code, data } = await commonAPI.getAction(
        `/users/getUserInfo/${this.user.username}`
      );
      if (code == 0) {
        let obj = data || {};
        this.userInfo = Object.assign(this.userInfo, obj);
      }
    },
    // 获取基础配置
    async getBasicSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/basic/get"
      );
      if (code == 0) {
        this.basicSetInfo = { ...data };
      } else {
        this.$message.error(message);
      }
    },
    // 获取安全配置
    async getSafeSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/safe/get"
      );
      if (code == 0) {
        this.safeSetInfo = { ...data };
      } else {
        this.$message.error(message);
      }
    },
    // 获取密码策略
    async getPswSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/pass/get"
      );
      if (code == 0) {
        this.pswSetInfo = { ...data };
      } else {
        this.$message.error(message);
      }
    },
    // 打开弹窗通用方法
    openDialog(ref) {
      this.$refs[ref].openModal();
    },
    // 修改密码
    updatePass() {
      this.$refs.updatePassForm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let obj = this.pswSetInfo;
          let form = this.$refs.updatePassForm.form;

          if (form.passwordStrength < obj.bmz) {
            this.$message.warning(this.$t("base.password.update_error"));
            return;
          }

          let user = JSON.parse(sessionStorage.getItem("user"));
          let params = { username: user.username, ...form };
          params.confirmPassword = encryptAES(params.confirmPassword);
          params.oldPassword = encryptAES(params.oldPassword);
          params.password = encryptAES(params.password);
          console.log(params);
          this.updatePassApi(params);
        }
      });
    },
    async updatePassApi(params) {
      const { code, message } = await commonAPI.postAction(
        "/config/changePassword",
        params
      );
      if (code == 0) {
        const that = this;
        that.$message.success(message);
        that.$cookies.remove("REMEMBER_ME");
        this.$store.dispatch("auth/loginOut");
      } else {
        this.$message.error(message);
      }
    },
    // 新增编辑安全问题
    saveQus() {
      this.$refs.safeForm.$refs.form.validate((valid) => {
        if (valid) {
          let arr = this.$refs.safeForm.form.questionVos;
          let flag = arr.every(
            (o) => (o.question && o.answer) || (!o.question && !o.answer)
          );
          if (flag) {
            let params = {
              userName: this.user.username,
              questionVos: arr,
            };
            (async () => {
              const { code, message } = await commonAPI.postAction(
                "/users/savePwdQuestion",
                params
              );
              if (code == 0) {
                this.$message.success(message);
                this.getUserInfo();
                this.$refs.safe.closeModal();
              } else {
                this.$message.error(message);
              }
            })();
          } else {
            this.$message.warning(this.$t("base.question.error_tip"));
          }
        } else {
          return false;
        }
      });
    },
    // 设置别名
    setAliasOk() {
      this.$refs.aliasForm.$refs.form.validate((valid) => {
        if (valid) {
          let alias = this.$refs.aliasForm.form.alias;
          (async () => {
            const { code, message } = await commonAPI.postAction(
              `/users/editUserAlias/${this.user.username}`,
              { alias: alias }
            );
            if (code == 0) {
              this.$message.success(message);
              this.getUserInfo();
              this.$refs.loginAlias.closeModal();
            } else {
              this.$message.error(message);
            }
          })();
        } else {
          return false;
        }
      });
    },
    // 邮箱、手机号加码
    formatterStar(val) {
      if (!val) return "";
      if (val.includes("@")) {
        let arr = val.split("@");
        return arr[0].length > 3
          ? `${arr[0].substring(0, 3)}****@${arr[1]}`
          : val;
      } else {
        return `${val.substring(0, 3)}****${val.substring(7)}`;
      }
    },
    // 绑定邮箱
    setMailOk() {
      this.$refs.emailForm.$refs.form.validate((valid) => {
        if (valid) {
          let form = this.$refs.emailForm.form;
          (async () => {
            const { code, message } = await commonAPI.postAction(
              `/users/bindEmail/${this.user.username}`,
              {
                captcha: form.code,
                account: form.email,
              }
            );
            if (code == 0) {
              this.$message.success(message);
              this.getUserInfo();
              this.$refs.email.closeModal();
            } else {
              this.$message.error(message);
            }
          })();
        } else {
          return false;
        }
      });
    },
    // 绑定手机号
    setPhoneOk() {
      this.$refs.phoneForm.$refs.form.validate((valid) => {
        if (valid) {
          let form = this.$refs.phoneForm.form;
          (async () => {
            const { code, message } = await commonAPI.postAction(
              `/users/bindPhone/${this.user.username}`,
              {
                captcha: form.code,
                account: form.mobile,
              }
            );
            if (code == 0) {
              this.$message.success(message);
              this.getUserInfo();
              this.$refs.phone.closeModal();
            } else {
              this.$message.error(message);
            }
          })();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.user_set::v-deep {
  .ant-list-item-meta-title {
    margin-bottom: 0;
  }
}
.list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--primary-color);
  .item {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 50px;
    color: #333;
    font-size: 14px;
    &:nth-child(odd) {
      background-color: #fff6f0;
    }
    .left {
      display: flex;
      width: 32%;
      min-width: 200px;
      align-items: center;
      .anticon {
        font-size: 20px;
        margin-right: 20px;
      }
    }

    .info {
      flex: 1;
    }
    .right {
      position: relative;
      .showArea {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(calc(-100% - 15px), -50%);
        font-weight: 500;
      }
    }
  }
}
</style>
